import { Component, inject } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { DatepickerService } from '@shared/services/datepicker.service';
import { SharedModule } from '@shared/shared.module';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';

@Component({
  selector: 'iho-empty-view',
  standalone: true,
  imports: [
    MatRippleModule,
    SharedModule
  ],
  templateUrl: './empty-view.component.html',
  styleUrls: ['./empty-view.component.scss'],
})
export class EmptyViewComponent {
  datepickerService = inject(DatepickerService)
  cdnUrl = cdnUrl
  openDatepicker() {
    this.datepickerService.setState(true);
  }
}
